import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  dialogRoot: { width: 600, background: "#fff" },
  dialogTitle: {
    height: 56,
    width: "100%",
    background: theme.palette.primary.main,
    color: "#fff",
    padding: 15,
    fontWeight: 500,
    fontSize: 18,
    textAlign: "center",
    textTransform: "uppercase"
  },
  dialogContent: { padding: "56px 30px 30px 30px" },
  autocomplete: {
    width: "100%"
  },
  option: {
    fontSize: 14
  },
  chip: {
    backgroundColor: theme.palette.info.light
  }
}));
